import React, { useState, useEffect } from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddEvent(props) {
  return(
    <PostAdd 
      targetVid={"event_categories"}
      addPostEndpoint={apiEndpoints.events}
      editRoute={"/events/edit"}
      entityType={"event"}
      pageTitle={"Create an event"}
      returnRoute={"/events-creator"}
    />
  )
}
